//e/o doc ready
function initMap() {
  var laapparel_lac = {
    lat: 33.986613,
    lng: -118.257677
  };
  var map = new google.maps.Map(document.getElementById('map'), {
    zoom: 12,
    disableDefaultUI: false,
    center: laapparel_lac,
    scrollwheel: false,
    navigationControl: false,
    scaleControl: false,
    streetViewControl: false,
    draggable: true,
    mapTypeControl: false,
  });
  var contentString = '<div id="content">' + '<div id="siteNotice">' + '</div>' + '<h4 id="firstHeading" class="firstHeading">Los Angeles Apparel</h4>' + '<div id="bodyContent">' + '<p><address>1020 E 59th St.<br>Los Angeles, CA 90001</address>' + '<p><a target="_blank" href="https://maps.app.goo.gl/3Qsa6HW6AxKKThVd6">' + 'Directions</a> ' + '</div>' + '</div>';
  var infowindow = new google.maps.InfoWindow({
    content: contentString
  });
  var myimg = "https://cdn.shopify.com/s/files/1/2152/0639/files/color-red-map-marker.jpg";
  var icon = {
    url: myimg, // url
    scaledSize: new google.maps.Size(20, 20), // scaled size
  };
  //Creating a marker and putting it on the map
  var marker = new google.maps.Marker({
    position: laapparel_lac,
    map: map,
    title: "Los Angeles Apparel",
    icon: icon,
    optimized: false,
  });
  marker.addListener('click', function() {
    infowindow.open(map, marker);
  });
  red_road_styles = [{
    "featureType": "administrative",
    "elementType": "labels.text.fill",
    "stylers": [{
      "color": "#444444"
        }]
    }, {
    "featureType": "administrative.country",
    "elementType": "geometry.fill",
    "stylers": [{
      "visibility": "on"
        }]
    }, {
    "featureType": "administrative.province",
    "elementType": "labels.icon",
    "stylers": [{
      "hue": "#ff0000"
        }, {
      "visibility": "on"
        }]
    }, {
    "featureType": "landscape",
    "elementType": "all",
    "stylers": [{
      "color": "#f2f2f2"
        }]
    }, {
    "featureType": "poi",
    "elementType": "all",
    "stylers": [{
      "visibility": "off"
        }]
    }, {
    "featureType": "road",
    "elementType": "all",
    "stylers": [{
      "saturation": -100
        }, {
      "lightness": 45
        }]
    }, {
    "featureType": "road.highway",
    "elementType": "all",
    "stylers": [{
      "visibility": "simplified"
        }]
    }, {
    "featureType": "road.arterial",
    "elementType": "labels.icon",
    "stylers": [{
      "visibility": "off"
        }]
    }, {
    "featureType": "transit",
    "elementType": "all",
    "stylers": [{
      "visibility": "off"
        }]
    }, {
    "featureType": "water",
    "elementType": "all",
    "stylers": [{
      "color": "#46bcec"
        }, {
      "visibility": "on"
        }]
    }];
  map.setOptions({
    styles: red_road_styles
  });
}
//end
